import type { FunctionalComponent } from "vue"
import type { JSX } from "vue/jsx-runtime"
import { useIDStack, type IStackItem, type UseIDStack } from "../useIDStack";

export type IAlert = {
  body: FunctionalComponent<any> | MaybeRef<JSX.Element>;
}

const alertStack = useIDStack<IAlert>();

export type UseAlerts = {
  alerts: ComputedRef<Array<IStackItem<IAlert>>>;
  push: (item: IAlert) => string;
  pop: (id?: string) => void;
  clear: () => void;
  count: ComputedRef<number>;
  stack: UseIDStack<IAlert>;
}

export const useAlerts = (): UseAlerts => {
  const alerts = computed(() => alertStack.items.value);
  const count = computed(() => alerts.value.length);

  const clear = () => {
    alertStack.clear();
  }

  const push = (item: IAlert): string => {
    const entry = alertStack.push(item);
    return entry.id;
  }

  const pop = (id?: string) => {
    alertStack.pop(id);
  }

  return {
    push,
    pop,
    clear,
    alerts,
    count,
    stack: alertStack
  }
}

export const globalAlerts = useAlerts();

export const clearAlerts = () => {
  globalAlerts.clear();
}

export const pushAlert = (item: IAlert): string => {
  return globalAlerts.push(item);
}

export const popAlert = (id?: string) => {
  return globalAlerts.pop(id);
}
